export default __webpack_public_path__ + "static/media/420.07412f83.png";